import { cn } from "@/utils/cn";
import { BarChart3, User, LogOut } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logoIcon from "@/assets/logo-icon.svg";
import { deleteCookie } from "cookies-next";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { OpenAPI } from "@/generated/admin/core/OpenAPI";

const menuItems = [
  { title: "광고 성과", href: "/stats", icon: BarChart3 },
  { title: "내 정보", href: "/profile", icon: User },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    deleteCookie("accessToken");
    OpenAPI.TOKEN = "";
    navigate("/login", { replace: true });
  };

  return (
    <div
      className={cn(
        "group/sidebar fixed left-0 top-0 z-40 flex h-screen flex-col bg-gray-800",
        "w-[60px] hover:w-[220px] transition-[width] duration-200 ease-in-out",
        "hover:shadow-2xl",
      )}
    >
      <div className="flex h-[60px] shrink-0 items-center overflow-hidden px-[15px]">
        <img src={logoIcon} alt="sweatch" className="h-[28px] w-[23px] shrink-0 object-contain" />
        <span className="ml-2.5 whitespace-nowrap text-sm font-semibold text-white opacity-0 transition-opacity duration-200 group-hover/sidebar:opacity-100">
          스웨치 광고 리포트
        </span>
      </div>
      <nav className="flex flex-1 flex-col">
        {menuItems.map((item) => {
          const isActive = location.pathname.startsWith(item.href);
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex items-center px-[17px] py-3 text-sm text-gray-300 hover:bg-gray-700 hover:text-white overflow-hidden",
                isActive && "border-r-4 border-teal-500 bg-gray-700 font-semibold text-white",
              )}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="ml-3 whitespace-nowrap opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-200">
                {item.title}
              </span>
            </Link>
          );
        })}
        <div className="flex-1" />
        <button
          onClick={handleLogout}
          className="flex items-center border-t border-gray-700 px-[17px] py-4 text-sm text-gray-400 hover:text-white overflow-hidden"
        >
          <LogOut className="h-5 w-5 shrink-0" />
          <span className="ml-3 whitespace-nowrap opacity-0 group-hover/sidebar:opacity-100 transition-opacity duration-200">
            로그아웃
          </span>
        </button>
      </nav>
    </div>
  );
}
